module.exports = __webpack_public_path__ + "media/images/envato-button-8294d61d674b0bd38eb2714f7c8af794.svg";